import DropdownButton from "~/components/ui/Admin/DropdownButton"
import Button from "~/components/ui/Button"
import Toggle from "~/components/ui/Toggle"
import { Cog6ToothIcon } from "@heroicons/react/24/outline"
import { useMemo } from "react"

interface DropdownOption {
  label: string
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
  onClick?: (e?: React.MouseEvent) => void
  content?: React.ReactNode
}

interface FilterDropdownProps {
  showOnlyStripePayments: boolean
  setShowOnlyStripePayments: (value: boolean) => void
  hideDeletedReservationPayments: boolean
  setHideDeletedReservationPayments: (value: boolean) => void
  isLoading?: boolean
}

const PaymentFiltersDropdown: React.FC<FilterDropdownProps> = ({
  showOnlyStripePayments,
  setShowOnlyStripePayments,
  hideDeletedReservationPayments,
  setHideDeletedReservationPayments,
  isLoading = false,
}) => {
  const enabledFiltersCount = useMemo(() => {
    let count = 0
    if (showOnlyStripePayments) count++
    if (!hideDeletedReservationPayments) count++
    return count
  }, [showOnlyStripePayments, hideDeletedReservationPayments])

  const options: DropdownOption[] = [
    {
      label: (
        <div className="flex items-center justify-between w-full px-2 py-2">
          <span className="text-sm text-gray-600">Show Only Stripe Payments</span>
          <Toggle checked={showOnlyStripePayments} onChange={setShowOnlyStripePayments} />
        </div>
      ),
      onClick: () => setShowOnlyStripePayments(!showOnlyStripePayments),
    },
    {
      label: (
        <div className="flex items-center justify-between w-full px-2 py-2">
          <span className="text-sm text-gray-600">Show Removed Reservation Payments</span>
          <Toggle
            checked={!hideDeletedReservationPayments}
            onChange={(value) => setHideDeletedReservationPayments(!value)}
          />
        </div>
      ),
      onClick: () => setHideDeletedReservationPayments(!hideDeletedReservationPayments),
    },
  ]

  return (
    <DropdownButton disabled={isLoading} options={options} autoWidth preventCloseOnClick minWidth={300} isMenuFixed>
      <Button
        variant="white"
        disabled={isLoading}
        size="small"
        shadow="small"
        type="button"
        dataTestId="payment-filter-options"
        className="flex justify-center items-center gap-2 relative !py-5.5"
      >
        <Cog6ToothIcon className="h-5 w-5 text-gray-600" aria-hidden="true" />
        <span className="text-gray-600">Filters</span>
        {!!enabledFiltersCount && (
          <span className="absolute -top-2 -right-2 flex h-4 w-4 items-center justify-center rounded-full bg-yellow-400 text-black text-xs font-medium">
            {enabledFiltersCount}
          </span>
        )}
      </Button>
    </DropdownButton>
  )
}

export default PaymentFiltersDropdown
